import request from '@/utils/request'
let preBase = 'mixApi'

// 签到有礼-登录
export const login = (data) => {
  return request({
    url: `${preBase}/signInAuth/login`,
    method: 'post',
    data,
    hideLoading: true,
    hideErrMsgToast: true,
  })
}
// 签到有礼-获取用户信息
export const getUserInfo = (data) => {
  return request({
    url: `${preBase}/signInGift/getUserInfo`,
    method: 'post',
    token: sessionStorage.getItem('signInGiftToken'),
    data,
    hideLoading: true,
  })
}
// 签到有礼-获取验证码
export const getVerCode = (data) => {
  return request({
    url: `${preBase}/signInGift/getVerCode`,
    method: 'post',
    token: sessionStorage.getItem('signInGiftToken'),
    data,
    hideLoading: true,
  })
}
// 签到有礼-绑定手机号
export const bindPhone = (data) => {
  return request({
    url: `${preBase}/signInGift/bindPhone`,
    method: 'post',
    token: sessionStorage.getItem('signInGiftToken'),
    data,
    hideLoading: true,
  })
}
// 签到有礼-获取签到活动信息
export const getSignActInfo = (data) => {
  return request({
    url: `${preBase}/signInGift/getSignActInfo`,
    method: 'post',
    token: sessionStorage.getItem('signInGiftToken'),
    data,
    hideLoading: true,
  })
}
// 签到有礼-获取签到统计
export const getSignInGiftCount = (data) => {
  return request({
    url: `${preBase}/signInGift/getSignInGiftCount`,
    method: 'post',
    token: sessionStorage.getItem('signInGiftToken'),
    data,
    hideLoading: true,
  })
}
// 签到有礼-获取月签名统计
export const getSignInMothRecord = (data) => {
  return request({
    url: `${preBase}/signInGift/getSignInMothRecord`,
    method: 'post',
    token: sessionStorage.getItem('signInGiftToken'),
    data,
    hideLoading: true,
  })
}
// 签到有礼-签到
export const signIn = (data) => {
  return request({
    url: `${preBase}/signInGift/signIn`,
    method: 'post',
    token: sessionStorage.getItem('signInGiftToken'),
    data,
    hideLoading: true,
  })
}
// 签到有礼-用户领奖分页
export const getSignInPages = (data) => {
  return request({
    url: `${preBase}/signInGift/pages`,
    method: 'post',
    token: sessionStorage.getItem('signInGiftToken'),
    data,
    hideLoading: true,
  })
}
// 签到有礼-领取按钮
export const sendCoupon = (data) => {
  return request({
    url: `${preBase}/signInGift/sendCoupon`,
    method: 'post',
    token: sessionStorage.getItem('signInGiftToken'),
    data,
    hideLoading: true,
  })
}
// 签到有礼-选择支付宝账号
export const selectAccount = (data) => {
  return request({
    url: `${preBase}/signInGift/selectAccount`,
    method: 'post',
    token: sessionStorage.getItem('signInGiftToken'),
    data,
    hideLoading: true,
  })
}
// 签到有礼-奖品详情
export const getPrizeOrderDetail = (data) => {
  return request({
    url: `${preBase}/signInGift/getPrizeOrderDetail/${data.id}`,
    method: 'post',
    token: sessionStorage.getItem('signInGiftToken'),
    data,
    hideLoading: true,
  })
}
